document.addEventListener('DOMContentLoaded', function () {
  if (!window.mz) {
    return
  }
  if (mz.context.filterShow) {
    $('.show-more .ttshowmorestyle').removeClass('autoscroll')
  }

  function afterUpdate() {
    $('.tt-title-total.listing-total-js').html('(' + mz.app.hits.total + ')')
    $('.tt-title-total.listing-total-js').css('display', 'initial')
    initImagesSize()
    lazyload()
    $('body').trigger('refreshCurrency')
    ttProductSmall()
    countDown(true)
    if ($('.tt-product .tt-product-inside-hover').length) {
      ttProductHover()
    }
    if ($('.product-parent').length) {
      wl_handler.init()
      compare.init()
    }
  }
  if (mz.app && mz.app.$bus) {
    mz.app.$bus.on('after-update', afterUpdate)
  }
})
